import { jsx as _jsx } from "react/jsx-runtime";
export default function Line(props) {
    return _jsx("line", Object.assign({}, props), void 0);
}
//# sourceMappingURL=Line.js.map